// extracted by mini-css-extract-plugin
export default {"cardWrapper":"search_cardWrapper__uWCYS","cardBodyWrapper":"search_cardBodyWrapper__to8be","columnsStyle":"search_columnsStyle__c5Fdj"};